import { replaceUnderscoresWithSpaces } from "../../../utils/functions"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import AnimatedLine from "../../svg/AnimatedLine"
import * as style from "./style.module.css"
import parse from "html-react-parser"
import React from "react"

const HowWeDo = props => {
  const {
    sectionClass,
    sectionContent,
    sectionSubTitle,
    sectionTitle,
    showSection,
    listItems,
  } = props

  return (
    <>
      {showSection === "yes" && (
        <section className={`${style.how_we_do_section} ${sectionClass}`}>
          <div className="container">
            <div>
              <SectionsTitle
                Content={sectionContent}
                SubTitle={sectionSubTitle}
                styleCss={{ display: "none" }}
                title={replaceUnderscoresWithSpaces(sectionTitle)}
              />

              <div className={style.how_we_do_content}>
                <div className={style.icon_wrap}>
                  <AnimatedLine />
                </div>
                <div className={style.box_wrap}>
                  {Array.isArray(listItems) &&
                    listItems?.map((item, index) => {
                      return (
                        <div key={index} className={style.box}>
                          <div className={style.box_info}>
                            <div className={style.icon_wrap}>
                              {parse(`${item?.workFlowIcon}`)}
                            </div>
                            <h3 className={style.box_title}>
                              {item?.workFlowTitle}
                            </h3>
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default HowWeDo
